// extracted by mini-css-extract-plugin
export default {"education":"Education_education__u2LAl","degree":"Education_degree__7OCT+","additional":"Education_additional__jXnVb"};